import React from 'react'
import FormattedMessage from '../../helpers/FormattedMessage'

import styles from './Button.module.scss'

interface IProps {
  buttonDescription: string
  buttonColor?: boolean
  onClick: () => void
  classWidth?: boolean
  center?: boolean
  disabled?: boolean
  icon?: any
  
}

export const Button = ({ buttonDescription, buttonColor, classWidth, center, onClick, disabled, icon = null }: IProps) => {
  return (
    buttonColor ?
      <div className={center ? styles.Center : ''}>
        <button
          onClick={onClick}
          className={`${classWidth ? styles.BlackButton : styles.BlackButtonWide} ${disabled && styles.Disabled}`}
          disabled={disabled}>
            {icon &&
          <img className={styles.IconPlus} src={icon} alt={'forward'}/>}
          <FormattedMessage id={buttonDescription}/>
        </button>
      </div>
      :
      <button
        onClick={onClick}
        className={`${styles.GreenButton} ${classWidth && styles.Wide} ${disabled && styles.Disabled}`}
        disabled={disabled}>
        <span className={styles.ButtonContent}>
          <FormattedMessage id={buttonDescription}/>
        </span>
      </button>
  )
}
